import React, { Fragment } from "react";
import styled from "styled-components";
import {
  StoreAgreement10,
  StoreAgreement11,
  StoreAgreement12,
  StoreAgreement13,
  StoreAgreement14,
  StoreAgreement15,
  StoreAgreement16,
  StoreAgreement2,
  StoreAgreement3,
  StoreAgreement4,
  StoreAgreement5,
  StoreAgreement6,
  StoreAgreement7,
  StoreAgreement8,
  StoreAgreement9,
} from "./storeAgreements";

const UserBodyBox = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  text-align: center;
  height: auto;
  &:after {
    display: block;
    content: "";
    clear: both;
  }
  ${({ theme }) => theme.media.mobile`
  width: 90%;
  border: 0px;
  border-radius: 0px;
    `}
`;

const UserIndividuallyBox = styled.div`
  float: left;
  padding-top: ${(props) => props.paddingTop || "0px"};
  margin-top: ${(props) => props.marginTop || "0px"};
  width: ${(props) => props.width || "100%"};
  border: ${(props) => props.border || "none"};
  overflow: hidden;
`;
const UserBorderTopBox = styled.div`
  float: left;
  padding-top: ${(props) => props.paddingTop || "0px"};
  margin-top: ${(props) => props.marginTop || "0px"};
  width: ${(props) => props.width || "100%"};
  border-top: ${(props) => props.borderTop || "inherit"};
`;

const UserSpan = styled.span`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "0px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  border-top: ${(props) => props.borderTop || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  margin: ${(props) => props.margin || "inherit"};
  position: ${(props) => props.position || "static"};
  ${({ theme }) => theme.media.mobile`
  border-bottom: none;
  font-size: 10px;
    `}
`;
const UserP = styled.p`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "0px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  ${({ theme }) => theme.media.mobile`
  font-size: 10px;
  line-height: 15px;
    `}
`;

const UserUl = styled.ul`
  display: block;
  width: ${(props) => props.width || "33.33%"};
  padding: ${(props) => props.padding || "0 40px"};
  box-sizing: border-box;
  float: left;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  ${({ theme }) => theme.media.mobile`
  width: 100%;
  border: 0px;
  border-radius: 0px;
    `}
`;

const Userli = styled.li`
  display: block;
  font-size: ${(props) => props.fontSize || "14px"};
  line-height: ${(props) => props.lineHeight || "27px"};
  padding: ${(props) => props.padding || "0 0px"};
  text-align: left;
  /* cursor: pointer; */
  color: #1e1e1e;
  font-weight: ${(props) => props.fontWeight || ""};
`;

export default function StoreBody() {
  return (
    <Fragment>
      <UserBodyBox>
        <UserIndividuallyBox>
          <UserSpan paddingTop="80px">
            주식회사 랩이오사 서비스 약관(서비스 가맹점용)입니다.
          </UserSpan>
        </UserIndividuallyBox>
        <UserIndividuallyBox paddingTop="96px" width="inherit">
          <div>
            <UserSpan
              color="#1e1e1e"
              fontSize="20px"
              border="1px solid #4d4d4d"
            >
              랩이오사 서비스 약관
            </UserSpan>
          </div>
        </UserIndividuallyBox>
        <UserIndividuallyBox marginTop="27px" border="1px solid #1e1e1e">
          <UserUl>
            <Userli fontSize="16px">제1장 환영합니다!</Userli>
            <UserUl padding="0 0 0 25px" width="100%">
              <Userli>제1조 목적</Userli>
              <Userli>제2조 정의</Userli>
              <Userli>제3조 약관의 명시와 설명 및 개정</Userli>
            </UserUl>
            <Userli fontSize="16px" padding="7px 0 0 0 ">
              제2장 서비스 이용
            </Userli>
            <UserUl padding="0 0 0 25px" width="100%">
              <Userli>제4조 서비스 이용계약</Userli>
              <Userli>제5조 서비스의 제공 및 변경</Userli>
              <Userli>제6조 서비스의 중단</Userli>
            </UserUl>
          </UserUl>
          <UserUl>
            <Userli fontSize="16px">제3장 개인정보처리</Userli>
            <UserUl padding="0 0 0 25px" width="100%">
              <Userli>제7조 회사의 의무</Userli>
              <Userli>제8조 서비스가맹점의 의무</Userli>
              <Userli>제9조 고객정보의 수집, 이용 및 처리</Userli>
              <Userli>제10조 개인정보보호</Userli>
            </UserUl>
          </UserUl>
          <UserUl>
            <Userli fontSize="16px">제4장 기타</Userli>
            <UserUl padding="0 0 0 25px" width="100%">
              <Userli>제11조 손해배상</Userli>
              <Userli>제12조 회사의 면책</Userli>
              <Userli>제13조 정보보호 및 비밀유지</Userli>
              <Userli>제14조 권리, 의무의 양도금지</Userli>
              <Userli>제15조 기타</Userli>
            </UserUl>
          </UserUl>
        </UserIndividuallyBox>
        <UserBorderTopBox
          paddingTop="55px"
          marginTop="80px"
          borderTop="2px solid #1e1e1e"
        >
          <UserIndividuallyBox>
            <UserSpan color="#1e1e1e" fontSize="20px" fontWeight="bold">
              제1장 환영합니다!
            </UserSpan>
            <UserSpan
              color="#1e1e1e"
              fontSize="16px"
              fontWeight="bold"
              paddingTop="40px"
            >
              제1조 목적
            </UserSpan>
            <UserP paddingTop="18px">
              본 약관은 주식회사 랩이오사(이하 "회사")가 제공하는 랩포인트
              서비스(서비스가맹점)를 이용함에 있어 회사와 서비스가맹점의
              권리·의무, 책임사항 및 기타 필요한 사항을 규정함을 목적으로 한다.
            </UserP>
            <StoreAgreement2></StoreAgreement2>
            <StoreAgreement3></StoreAgreement3>
            <UserSpan
              color="#1e1e1e"
              fontSize="20px"
              fontWeight="bold"
              margin="55px 0 0 0"
              paddingTop="55px"
              borderTop="1px solid #e1e1e1"
            >
              제2장 서비스 이용
            </UserSpan>
            <StoreAgreement4></StoreAgreement4>
            <StoreAgreement5></StoreAgreement5>
            <StoreAgreement6></StoreAgreement6>
            <UserSpan
              color="#1e1e1e"
              fontSize="20px"
              fontWeight="bold"
              margin="55px 0 0 0"
              paddingTop="55px"
              borderTop="1px solid #e1e1e1"
            >
              제3장 개인정보처리
            </UserSpan>
            <StoreAgreement7></StoreAgreement7>
            <StoreAgreement8></StoreAgreement8>
            <StoreAgreement9></StoreAgreement9>
            <StoreAgreement10></StoreAgreement10>
            <UserSpan
              color="#1e1e1e"
              fontSize="20px"
              fontWeight="bold"
              margin="55px 0 0 0"
              paddingTop="55px"
              borderTop="1px solid #e1e1e1"
            >
              제4장 기타
            </UserSpan>
            <StoreAgreement11></StoreAgreement11>
            <StoreAgreement12></StoreAgreement12>
            <StoreAgreement13></StoreAgreement13>
            <StoreAgreement14></StoreAgreement14>
            <StoreAgreement15></StoreAgreement15>
            <StoreAgreement16></StoreAgreement16>
          </UserIndividuallyBox>
        </UserBorderTopBox>
      </UserBodyBox>
    </Fragment>
  );
}
